<template>
  <div>
    <v-dialog v-model="openDialog" max-width="1200px" persistent scrollable>
      <template v-slot:activator="{ on }">
        <mf-button :disabled="!selectedSegmentationAnalyticsConfigurationsIds.length" label="Selecionar período analisado" v-on:click.native="on.click" />
      </template>
      <v-card>
        <v-card-title>
          <span class="mf-h6 primary-text">Selecionar período analisado</span>
        </v-card-title>
        <v-card-text>
          <div style="max-height: 700px; overflow-y: auto; overflow-x: hidden">
            <mf-search v-model="search" hide-details placeholder="Busque por períodos análisados" />

            <v-data-table :headers="headers" :items="items" :search="search" :loading="loading" :custom-items-per-page="10">
              <template #item="{ item }">
                <tr class="cursor-pointer" @click="toggleAnalyticsPeriods(item)">
                  <td>
                    <v-simple-checkbox
                      :value="selectedAnalyticsPeriodsIds.includes(item._id)"
                      color="primary"
                      :ripple="false"
                      @input="toggleAnalyticsPeriods(item)"
                    />
                  </td>
                  <td class="nowrap-row">
                    <mf-tooltip :disabled="!item.dynamic" variant="secondary" top max-width="300">
                      <template v-slot:activator>
                        <div class="d-flex align-center">
                          {{ item.dynamic ? 'Últimos 90 dias (Período dinâmico)' : item.title }}
                          <mf-icon v-if="item.dynamic" color="cinza-0" size="20" class="ml-1" icon="info" />
                        </div>
                      </template>
                      Esse período é referente a análise RFV que é atualizada todos os dias, por isso o período é dinâmico e irá sempre contemplar os últimos 90
                      dias. Os outros períodos continuam estáticos.
                    </mf-tooltip>
                  </td>
                  <td>
                    <span>
                      {{ getDate(item.initialDate) }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ getDate(item.finalDate) }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ getDate(item.createdAt) }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Confirmar',
              action: save,
              isVisible: true,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(AnalyticsPeriod, index) in selectedAnalyticsPeriod"
        :key="`chip-${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeAnalyticsPeriod(index)"
      >
        <span>{{ AnalyticsPeriod.title }}</span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { getUnits, getPeriod } from '@/config/helpers.js'
import { QUERY_GET_A_HUB_ANALYTICS_PERIODS } from '@/modules/clientes/segmentation/graphql'
import { mapGetters } from 'vuex'
export default {
  name: 'CriterioSelectAnalyticsPeriod',
  props: {
    currentIndex: Number,
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    componentParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: '',
      openDialog: false,
      loading: false,
      items: [],
      selectedAnalyticsPeriod: [],
      selectedAnalyticsPeriodsIds: [],
    }
  },
  computed: {
    ...mapGetters(['selectedSegmentationAnalyticsConfigurationsIds']),
    queryVariables() {
      return {
        analyticConfigurationsIds: this.selectedSegmentationAnalyticsConfigurationsIds,
        units: this.units ? this.units : [],
        sort: ['dynamic', 'finalDate'],
        sortDirection: ['DESC', 'DESC'],
      }
    },
    headers() {
      return [
        {
          text: '',
          value: '_id',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Título',
          value: 'title',
          width: '30%',
        },
        {
          text: 'Início',
          value: 'initialDate',
          width: '20%',
        },
        {
          text: 'Término',
          value: 'finalDate',
          width: '20%',
        },
        {
          text: 'Criado em',
          value: 'createdAt',
          width: '20%',
        },
      ]
    },
  },
  watch: {
    selectedAnalyticsPeriod: {
      deep: true,

      handler(value) {
        this.selectedAnalyticsPeriodsIds = value.map(({ _id }) => _id)
      },
    },
    selectedSegmentationAnalyticsConfigurationsIds: {
      deep: true,

      handler(value) {
        this.getPeriodsData()
      },
    },
  },
  async mounted() {
    await this.getPeriodsData()

    if (this.selectedAnalyticsPeriod) this.selectedAnalyticsPeriodsIds = this.selectedAnalyticsPeriod.map(({ _id }) => _id)
    this.setInitialState()
    this.validate()
  },
  methods: {
    getUnits,
    getPeriod,
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    async getPeriodsData() {
      const { aHubAnalyticsPeriods } = await this.$apollo
        .query({
          query: QUERY_GET_A_HUB_ANALYTICS_PERIODS,
          variables: this.queryVariables,
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              aHubAnalyticsPeriods: { aHubAnalyticsPeriods },
            },
          }) => {
            return { aHubAnalyticsPeriods }
          }
        )
      this.items = aHubAnalyticsPeriods
    },
    setInitialState() {
      if (this.initialValue && this.initialValue.length) {
        this.selectedAnalyticsPeriodsIds = this.initialValue
      }
      this.items.map((item) => {
        if (this.selectedAnalyticsPeriodsIds.includes(item._id)) {
          this.selectedAnalyticsPeriod.push(item)
        }
      })
    },
    getDate(date) {
      if (!date) return '-'
      return DateTime.fromISO(date.toString()).toFormat('dd/MM/yyyy')
    },
    toggleAnalyticsPeriods(toggledAnalyticsPeriod) {
      if (!this.selectedAnalyticsPeriod.length) {
        this.selectedAnalyticsPeriod = [toggledAnalyticsPeriod]
        return
      }
      const isChecked = this.selectedAnalyticsPeriod.findIndex((analyticsConfiguration) => analyticsConfiguration._id === toggledAnalyticsPeriod._id)
      this.selectedAnalyticsPeriod = isChecked !== -1 ? [] : [toggledAnalyticsPeriod]
    },
    removeAnalyticsPeriod(index) {
      this.selectedAnalyticsPeriod.splice(index, 1)
    },
    isValid() {
      return Boolean(this.selectedAnalyticsPeriod && this.selectedAnalyticsPeriod.length)
    },
    closeDialog() {
      this.openDialog = false
    },
    save() {
      this.$emit('input', {
        currentValue: this.selectedAnalyticsPeriod.map(({ _id }) => _id),
        currentChildren: this.values[0],
        currentIndex: this.currentIndex,
      })
      this.validate()
      this.closeDialog()
    },
  },
}
</script>
